import {
  TAGS_GET_BEGIN,
  TAGS_GET_FAIL,
  TAGS_GET_SUCCESS,
} from "../actionTypes";

const initialState = {
  tags: [],
  loading: false,
  error: null,
};

export default function (state = initialState, action) {
  switch (action.type) {
    case TAGS_GET_BEGIN: {
      return {
        ...state,
        loading: true,
        error: null,
      };
    }
    case TAGS_GET_SUCCESS: {
      return {
        ...state,
        loading: false,
        error: null,
        tags: action.payload,
      };
    }
    case TAGS_GET_FAIL: {
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    }
    default:
      return state;
  }
}
